<template>
    <div class="pageWarp">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle" backgroundColor="transparent"></Title-Box>


        <div class="content_box display_flex jus-c">
            <!-- 右边导出按钮 -->
            <!-- <button @click="exportEvent" class="butStyle pinkBtn exportBtn">
                <i class="exportIcon"></i>
                <span>导出</span>
            </button> -->

            <!-- module切换-右边模块类型 -->
            <ul class="right_menu boxs flex_v">
                <li v-for="(item, index) in moduleType.textArr"
                    :key="index"
                    @click="moduleLi(item, index)"
                    :class="{is_active: moduleType.nowIndex==index}"
                    class="flex_h_hC_vC"
                >
                    {{item.name}}
                </li>       
            </ul>

            <!-- 中间表单 -->
            <div class="g_form_box">

                <div class="titleLine flex-row ite-c">
                    <span>冻结金信息</span>
                </div>
                <div class="border_box">
                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            冻结合约编号
                        </span>
                        <span class="flex_h_hC_vC row_value greenT">
                            {{result.id}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            状态
                        </span>
                        <span class="flex_h_hC_vC row_value">
<!--                          订单状态，0 未完成、1 导入成功、2 导入失败、3 冻结成功、4 冻结失败-->
                             <template v-if="result.status == '0'">
                                        未完成
                                    </template>
                                    <template v-if="result.status == '1'">
                                        导入成功
                                    </template>
                                    <template v-if="result.status == '2'">
                                        导入失败
                                    </template>
                                    <template v-if="result.status == '3'">
                                        冻结成功
                                    </template>
                                    <template v-if="result.status == '4'">
                                        冻结失败
                                    </template>
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            合同人姓名
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.user_name}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            证件类型
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            <template v-if="result.cert_type == '1010'">
                                身份证
                            </template>
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            证件号码
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.cert_id}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            手机号码
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.mobile}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            剩余冻结金额(元)
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{result.residue_unfreeze_fee| centsToYuan}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            原始冻结金额(元)
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{result.contract_at| centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            分期解冻期数(月)
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.periods}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            每期解冻金额(元)
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{result.unfreeze_month_money| centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            累计解冻金额(元)
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{result.has_unfreeze_at| centsToYuan}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            已解冻期数
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.has_unfreeze_periods}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            来账冻结开始时间
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.frz_stdt}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            来账冻结终止日期
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.frz_tmdt}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            合同号(银行)
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.bill_id}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            银行保证金订单号
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{result.bill_id_third_sys}}
                        </span>
                    </div>
                </div>
                
                <div class="tabs_table_box boxs">
                    <!-- 表格类型切换 -->
                    <ul class="tabType clearfix">
                        <li v-for="(item,index) in tabData.textArr"
                            @click="tabLi(item, index)"
                            :class="{on:tabData.nowIndex==index}"
                        >
                            {{item}}
                        </li>
                    </ul>

                    <!-- 解冻明细表-tabData.nowIndex == 0 -->
                    <el-table :data="unfrozen.tableData"
                                v-show="tabData.nowIndex == 0"
                                style="width: 100%;font-size: 12px;margin-top: 20px;"
                                class="tableTheadGray3"
                                border
                                fit
                                tooltip-effect="dark"
                    >
                        <el-table-column label="解冻编号" prop="id" min-width="200" header-align="center" align="center" 
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="解冻期" prop="periods" width="137" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" >
                              <span>
                                      {{scope.row.periods}} /{{scope.row.sumPeriods}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="解冻处理时间" prop="unfreeze_time" width="137" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" class="orangeText" v-if="scope.row.unfreeze_time !=undefined && scope.row.unfreeze_time !=null">
                              <span >
                                  {{formatDate(scope.row.unfreeze_time)}}
                                </span>
                            </template>

                        </el-table-column>
                        <el-table-column label="解冻金额 (元)" prop="actual_unfreeze_at" width="110" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" class="orangeText">
                              <span class="orangeText">
                                      {{scope.row.actual_unfreeze_at | centsToYuan}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="处理状态" prop="stateText" width="98" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :class="{orangeT:scope.row.state=='1', lightGT:scope.row.state=='5'}">
<!--                                     // 状态，1-待核销、2-已销账、3-未销账、4-待解冻、5-已解冻、6-已违约、7-延期滞纳-->
                                    <template v-if="scope.row.status == '1'">
                                        待核销
                                    </template>
                                    <template v-if="scope.row.status == '2'">
                                        已解冻
                                    </template>
                                    <template v-if="scope.row.status == '3'">
                                        未销账
                                    </template>
                                    <template v-if="scope.row.status == '4'">
                                        待解冻
                                    </template>
                                    <template v-if="scope.row.status == '5'">
                                        已解冻
                                    </template>
                                    <template v-if="scope.row.status == '6'">
                                        已违约
                                    </template>
                                    <template v-if="scope.row.status == '7'">
                                        延期滞纳
                                    </template>
                                    <template v-if="scope.row.status == '8'">
                                        已作废
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <p v-if="tabData.nowIndex == 0"
                        class="table_bottom flex-row jus-fe ite-fe"
                    >
                        共
                        <span class="greenT flex-row ite-fe">
                            &nbsp;{{unfrozen.total}}&nbsp;
                        </span>
                        条，合计解冻金额
                        <span class="orangeT px18T flex-row ite-fe">
                            &nbsp;{{unfrozen.totalAmount| centsToYuan}}&nbsp;
                        </span>
                        元
                    </p>

                    <!-- 扣款明细表-tabData.nowIndex == 1 -->
                    <el-table :data="deduction.tableData"
                                v-show="tabData.nowIndex == 1"
                                style="width: 100%;font-size: 12px;margin-top: 20px;"
                                class="tableTheadGray3"
                                border
                                fit
                                tooltip-effect="dark"
                    >
                        <el-table-column label="扣款事项" prop="withhold_cause" width="100" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="扣款编号" prop="id" width="144" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="扣款期" prop="periods" width="137" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" >
                              <span>
                                      {{scope.row.periods}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="扣款金额(元)" prop="withhold_money" width="100" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" class="orangeText">
                              <span class="orangeText">
                                      {{scope.row.withhold_money | centsToYuan}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="扣款原因" prop="note" min-width="150" header-align="center" align="left"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="扣款时间" prop="withhold_time" width="90" header-align="center" align="center"
                                         ></el-table-column>
                    </el-table>
                    <p v-if="tabData.nowIndex == 1"
                        class="table_bottom flex-row jus-fe ite-fe"
                    >
                        共
                        <span class="greenT flex-row ite-fe">
                            &nbsp;{{deduction.total}}&nbsp;
                        </span>
                        条，合计扣款金额
                        <span class="orangeT px18T flex-row ite-fe">
                            &nbsp;{{deduction.totalAmount | centsToYuan}}&nbsp;
                        </span>
                        元
                    </p>
                </div>


                <div class="titleLine flex-row ite-c">
                    <span>冻结金日志</span>
                </div>
                <div class="table_box boxs">
                    <el-table :data="logTableData"
                                style="width: 100%;font-size: 12px"
                                class="tableTheadGray3"
                                border
                                fit
                                tooltip-effect="dark"
                    >
                        <el-table-column label="创建时间" prop="log_time" width="90" header-align="center" align="center"
                                         ></el-table-column>
                        <el-table-column label="扣款事项" prop="withhold_cause" min-width="88" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="业务编号" prop="fill_id" width="110" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="减去金额(元)" prop="amount" width="108" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" class="orangeText">
                              <span class="orangeText">
                                      {{scope.row.amount | centsToYuan}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="涉及月份" prop="involve_month" min-width="160" header-align="center" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column label="更新剩余冻结金额(元)" prop="balance" width="137" header-align="center" align="center"
                                         show-overflow-tooltip>
                            <template slot-scope="scope" class="orangeText">
                              <span class="orangeText">
                                      {{scope.row.balance | centsToYuan}}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>


                <div class="flex-row jus-c" style="margin: 24px 0 31px;">
                    <button @click="goBack()" class="butStyle close_btn">关 闭</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
    import {
        freezeFeeDetailFreezeInfo,
        freezeFeeDetailunfreezeDetail,
        freezeFeeDetailWithholdDetail,
        getFillLogList
    } from '@/api/Tbs/FrozenFeeManage/frozenFeeManage.js'

    export default {
        components: {
            TitleBox
        },
        data() {
            return {
                id:null,
                result:{order_id:null},
                //标题
                topTitle: {
                    title: '冻结金管理',
                    subTit: '详情'
                },
                // 右边模块类型
                moduleType: {
                    textArr: [
                        {name: '冻结金信息', value: 0},
                        {name: '冻结金日志', value: 1},
                    ],
                    nowIndex: 0
                },


                // 表格类型切换
                tabData: {
                    textArr: ['解冻明细', '扣款明细'],
                    nowIndex: 0
                },

                // 解冻明细-表格相关数据
                unfrozen: {
                    // 表格数据
                    tableData: [],
                    // 表格数据总数
                    total: 0,
                    // 表格总金额
                    totalAmount: 0,
                },
                // 扣款明细-表格相关数据
                deduction: {
                    // 表格数据
                    tableData: [],
                    // 表格数据总数
                    total: 0,
                    // 表格总金额
                    totalAmount: 0,
                },


                // 冻结金日志
                logTableData:[],
            }
        },
        created() {
            this.initRouterParam();
            this.getLogData();
        },
        methods: {
            // 获取路由携带参数
            initRouterParam() {
                this.id = this.$route.query.id;
                this.getUnfrozenDataList();
                this.freezeFeeDetailFreezeInfo();
            },
            // 切换模块类型
            moduleLi(item, index) {
                this.moduleType.nowIndex = index;
                this.scrollIntoView(index);
            },
            // 把对应的模块内容滚动到可视区域
            scrollIntoView(index){
                document.querySelectorAll(".titleLine")[index].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            },
            // 关闭按钮-返回上一页
            goBack(){
                this.$router.go(-1);
            },
            formatDate: function (date) {
                return date.substr(0,4)+"年"+date.substr(4,6)+"月";
            },

            // 表格类型切换-切换tabs表格
            tabLi(item, index) {
                // 0:'解冻明细', 1:'扣款明细'
                this.tabData.nowIndex = index;

                if(item == '解冻明细') {
                    this.getUnfrozenDataList()
                }
                else if(item == '扣款明细') {
                    this.freezeFeeDetailWithholdDetail()
                }

            },
            // 获取冻结金信息
            async freezeFeeDetailFreezeInfo() {
                try {
                    console.log("this.id:"+this.id);
                    const result = await freezeFeeDetailFreezeInfo({id:this.id});
                    console.log(result);
                    this.result = result.data;
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },
            // 获取解冻明细
            async getUnfrozenDataList() {
                try {
                    console.log("this.id:"+this.id);
                    const result = await freezeFeeDetailunfreezeDetail({id:this.id});
                    console.log(result);
                    this.unfrozen.tableData= result.data.data;

                    this.unfrozen.total = result.data.nums;
                    this.unfrozen.totalAmount = result.data.sum_actual_unfreeze_at;
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },
            // 获取扣款明细
            async freezeFeeDetailWithholdDetail() {
                try {
                    console.log("this.id:"+this.id);
                    const result = await freezeFeeDetailWithholdDetail({id:this.id});
                    console.log(result);
                    this.deduction.tableData= result.data.data;

                    this.deduction.total = result.data.nums;
                    this.deduction.totalAmount = result.data.sum_withhold_money;
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },


            // 导出
            exportEvent() {
            },
            // 获取日志
            async getLogData() {
                try {
                    console.log("this.id:"+this.id);
                    const result = await getFillLogList({id:this.id});
                    console.log(result);
                    this.logTableData= result.data;
                } catch (e) {
                    this.$message.error('接口请求失败:' + e.msg);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .pageWarp {
        height: calc(100vh - 88px);
    }

    .greenT  {
        color: #2DBAA5 !important;
    }
    .lightGT {
        color: #76C819 !important;
    }
    .orangeT {
        color: #FA6241 !important;
    }
    .grayT {
        color: #B7B2AF !important;
    }
    .px18T {
        font-size: 18px;
    }

    .exportBtn {
        position: absolute;
        top: -38px;
        right: 5px;

        width: 72px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        border-radius: 4px;
        &:hover {
            background-color: rgb(247, 143, 120);
        }
    }

    .exportBtn .exportIcon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
        background-size: 14px 14px;
    }


    // 右边模块目录
    .right_menu {
        position: fixed;
        top: 118px;
        right: 20px;

        width: 144px;
        padding: 12px 12px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 7px;
        box-shadow: 0px 12px 24px rgba(0,0,0,0.05);

        z-index: 22;
    }
    .right_menu li {
        width: 120px;
        height: 32px;
        border-radius: 7px;
        background: #ffffff;
        color: #333333;
        font-size: 12px;
    }
    .right_menu li+li {
        margin-top: 1px;
    }
    .right_menu li.is_active,
    .right_menu li:hover {
        color: #ffffff;
        background: #FA6241;
    }


    .content_box {
        width: 100%;
        // min-width: calc( 144px + 144px + 900px );
        // min-width: 900px;
        min-width: calc( 144px + 900px );
        padding-right: 144px;
        box-sizing: border-box;
        margin-top: 2px;
        position: relative;
    }

    .g_form_box {
        width: 899px;
        // width: auto;
    }

    // 模块标题
    .g_form_box .titleLine {
        width: 100%;
        height: 16px;
        margin-top: 13px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .g_form_box .titleLine span {
        line-height: 16px;
        font-size: 12px;
        font-weight: bold;
        color: #2B2727;
    }

    .g_form_box .titleLine span::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 16px;
        margin-right: 6px;
        background: #FA6241;
        vertical-align: middle;
    }
    


    // 模块
    .g_form_box .border_box {
        width: 899px;
        margin-top: 13px;
        background: #EEEEEE;
        border: 1px solid #EEEEEE;
    }

    .g_form_box .form_row {
        width: auto;
        // min-width: 449px;
        height: 36px;
        min-height: 36px;
        // line-height: 36px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .g_form_box .form_row+.form_row {
        margin-top: 1px;
    }
    // .g_form_box .form_row.no_border {
    //     border-bottom: none;
    // }

    .g_form_box .form_row span+span {
        margin-left: 1px;
    }

    .g_form_box .form_row .row_title {
        width: 144px;
        height: 100%;
        background: #F5F5F5;
        color: #7F7F7F;
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // text-align: center;
    }

    .g_form_box .form_row .row_value {
        width: 304px;
        height: 100%;
        background: #FFFFFF;
        color: #333333;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }



    // 模块提示
    .g_form_box .tip_line {
        width: 100%;
        line-height: 16px;
        color: #7F7F7F;
        font-size: 12px;
        margin-top: 12px;
    }


    // 日志(时间线)
    .g_form_box .time_line_box {
        width: 100%;
        margin-top: 12px;
        color: #B7B2AF;
        font-size: 12px;
        background: #ffffff;
        padding: 16px 12px;
        box-sizing: border-box;
    }

    // 日志(表格)
    .g_form_box .table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 21px 21px;
        box-sizing: border-box;
    }


    // Tabs 标签页(标签页表格)
    .g_form_box .tabs_table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 10px 21px 21px;
        box-sizing: border-box;
    }

    /*表格切换*/
    .tabs_table_box .tabType {
        background: #fff;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #EEEEEE;
    }

    .tabType li {
        float: left;
        width: 80px;
        color: #7F7F7F;
        font-size: 12px;
        cursor: pointer;
        position: relative;
    }
    .tabType li:after {
        content: '';
        position: absolute;
        width: 80px;
        height: 4px;
        background: transparent;
        bottom: -4px;
        left: 0;
    }

    .tabType li.on {
        color: #FA6241;
    }
    .tabType li.on:after {
        background: #FA6241;
    }

    .tabs_table_box .table_bottom {
        // height: 24px;
        // height: 16px;
        font-size: 12px;
        font-weight:400;
        line-height: 16px;
        // line-height: 24px;
        color: #2B2727;
        margin-top: 20px;
        background: #fff;
        // background: rgb(199, 148, 148);
    }
    .tabs_table_box .table_bottom span {
        height: 100%;
    }
    .tabs_table_box .table_bottom span.px18T {
        height: 100%;
        line-height: 18px;
    }



    // 关闭按钮
    .close_btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-radius: 4px;
        background: #FFFFFF;
        color: #2B2727;
        color: #666666;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        &:hover {
            // background-color: #f1f1f1;
            border: 1px solid #d1d0d0;
        }
    }
</style>

